$(document).ready(function() {
    // owl-carousel3
    var owl = $('.owl-banners');
    owl.owlCarousel({
      items: 1,
      margin: 30,
      // center: true,
      nav: false,
      loop: true,
      autoplay:true,
      autoplayTimeout:5000,
    })
    
    // owl-What-Parents
    var owl = $('.owl-What-Parents');
    owl.owlCarousel({
      margin: 30,
      // center: true,
      nav: true,
      loop: true,
      autoplay:true,
      autoplayTimeout:2300,
      navText:["<i class='bi bi-caret-left-fill'></i>","<i class='bi bi-caret-right-fill'></i>"],
      responsive: {
        0: {
          items: 1
        },
        600: {
          items: 2
        },
        868: {
          items: 2
        },
        1000: {
          items: 3  
        }
      }
    })

    // owl-Look-Whos-Rockin
    var owl = $('.owl-Look-Whos-Rockin');
    owl.owlCarousel({
      // center: true,
      margin: 20,
      nav: false,
      loop: true,
      dots: true,
      // autoWidth:true,
      autoplay:true,
      autoplayTimeout:3300,
      responsive: {
        0: {
          items: 2,
        },
        200: {
          items: 2,
          // autoWidth:false,
          // center: false,
        },
        576: {
          items: 2,
        },
        768: {
          items: 3,
        },
        992: {
          items: 4,
        }
      }
    })

    // $('footer .rows .col-lg-3:nth-child(1)').addClass('col-lg-2');
    // $('footer .rows .col-lg-3:nth-child(1)').removeClass('col-lg-3');
    // $('footer .rows .col-lg-3:nth-child(4)').addClass('col-lg-4');
    // $('footer .rows .col-lg-3:nth-child(4)').removeClass('col-lg-3');

    // navbar scroll
    $(document).scroll(function () {
      var scroll = $(this).scrollTop();
      // var topDist = $(".Brews-Kratom-lyte-sec").position();
      if (scroll > 400) {
          $('.navs').addClass("navs-top");
          $('.scroll-tops').addClass("scroll-top");
      } else {
        $('.navs').removeClass("navs-top");
        $('.scroll-tops').removeClass("scroll-top");
      }
    });

    $(document).scroll(function () {
      var scroll = $(this).scrollTop();
      if (scroll > 300) {
          $('.scroll-tops').addClass("scroll-top");
      } else {
        $('.scroll-tops').removeClass("scroll-top");
      }
    });

    // top scroll
    $('#top').click(function () {
      $('body,html').animate({
          scrollTop: 0
      }, 2000);
    });
  })

document.addEventListener("DOMContentLoaded", function () {
  const inputs = document.querySelectorAll(".inptuts");
  inputs.forEach(input => {
    input.addEventListener("change", function () {
      if (this.checked) {
        // Close all sibling dropdown checkboxes
        inputs.forEach(otherInput => {
          if (otherInput !== this) {
            otherInput.checked = false;
          }
        });
      }
    });
  });
});

// if($('.insta-carousel2')){
//   $('.insta-carousel2').owlCarousel({
//     autoplay: false,
//     loop: true,
//     margin: 20,
//     center: true,
//     dots: false,
//     slideTransition: 'linear',
//     autoplayTimeout: 4500,
//     autoplayHoverPause: true,
//     autoplaySpeed: 4500,
//     responsive: {
//         0: {
//             items: 2
//         },
//         500: {
//             items: 2
//         },
//         600: {
//             items: 3
//         },
//         800: {
//             items: 3
//         },
//         1200: {
//             items: 4
//         }
//     }
// });
// $('.video-back').vidbacking({
//     'masked': true
// });
// }

new MutationObserver(async () => {
  const wrapper = document.querySelector('#candyrack-slider-cart-wrapper');
  if (!wrapper) return;
  const cart = wrapper.querySelector('#candyrack-slider-cart');
  if (!cart) return;
  // Create container if not exists
  let msg = cart.querySelector('.free-shipping-message');
  if (!msg) {
    msg = document.createElement('div');
    msg.className = 'free-shipping-message';
    cart.prepend(msg);
  }
  try {
    const res = await fetch('/cart.js');
    const cartData = await res.json();
    // Shopify returns cents
    const subtotal = cartData.total_price / 100;
    const FREE_SHIPPING_LIMIT = 50;
    const remaining = (FREE_SHIPPING_LIMIT - subtotal).toFixed(2);
    if (subtotal >= FREE_SHIPPING_LIMIT) {
      msg.textContent = '🎉 You’ve unlocked FREE SHIPPING!';
    } else {
      msg.textContent = `Add $${remaining} more to get FREE SHIPPING`;
    }
  } catch (e) {
    console.error('Cart API error', e);
  }
}).observe(document.body, { childList: true, subtree: true });


